import { z } from 'zod';

export const WebclientAccessGetSchema = z.object({
  companyId: z.string(),
  configId: z.string(),
  origin: z.string(),
  // * Rows written before the pattern normalisation carry no real address
  lastSeenUrl: z.string().optional(),
  accessCount: z.number(),
  lastAccessedAt: z.date(),
});

export const WebclientAccessCreateSchema = z.object({
  companyId: z.string(),
  configId: z.string(),
  origin: z.string(),
  lastSeenUrl: z.string(),
  lastAccessedAt: z.date(),
});

export const WebclientAccessUsageParamsSchema = z.object({
  configId: z.string(),
});

export const WebclientAccessUsageEntrySchema = z.object({
  origin: z.string(),
  lastSeenUrl: z.string().optional(),
  accessCount: z.number(),
  lastAccessedAt: z.date(),
});

export const WebclientAccessUsageResponseSchema = z.object({
  totalOrigins: z.number(),
  entries: z.array(WebclientAccessUsageEntrySchema),
});
